/**
 * Lenient parsing and formatting of the values pilots type into a navlog.
 * Everything here accepts the messy, comma-decimal, sign-suffixed forms that
 * appear on paper forms and normalises them.
 */
/** Parse a number the way a pilot writes it: "2,5", "-3", "6-", "115.5". NaN if absent. */
export function num(s) {
    if (s == null)
        return NaN;
    const t = String(s).replace(',', '.').replace(/[^\d.+-]/g, '');
    return t === '' ? NaN : parseFloat(t);
}
/** Parse "360/15", "360 / 15", "36015" is NOT accepted (ambiguous). */
export function parseWind(s) {
    const m = String(s ?? '').match(/(\d{1,3})\s*\/\s*(\d{1,3})/);
    return m ? { dir: +m[1], spd: +m[2] } : null;
}
/**
 * Wind correction angle as written on the LBA form: "4+" (right/plus), "3-" (left/minus).
 * Also accepts "+4", "-3", "4". Positive = correction to the right.
 */
export function parseWca(s) {
    const t = String(s ?? '').trim();
    let m = t.match(/^(\d+(?:[.,]\d+)?)\s*([+-])$/);
    if (m)
        return (m[2] === '-' ? -1 : 1) * num(m[1]);
    m = t.match(/^([+-]?\d+(?:[.,]\d+)?)$/);
    return m ? num(m[1]) : NaN;
}
/** Format a WCA the LBA way: 4 → "4+", -3 → "3-", 0 → "0". */
export function fmtWca(w) {
    const r = Math.round(Math.abs(w));
    if (r === 0)
        return '0';
    return `${r}${w >= 0 ? '+' : '-'}`;
}
/** Normalise a heading to 1–360 (360 rather than 0, as written on forms). */
export function norm360(d) {
    let x = Math.round(d) % 360;
    if (x <= 0)
        x += 360;
    return x;
}
/** Parse "HH:MM", "H:MM", "HHMM", "HH.MM" → minutes since midnight. NaN if invalid. */
export function parseHM(s) {
    const m = String(s ?? '').trim().match(/^(\d{1,2})[:.,]?([0-5]\d)$/);
    return m ? +m[1] * 60 + +m[2] : NaN;
}
/** Format minutes → "HH:MM", wrapping past midnight (24h). Callers that care about day rollover must check the raw value. */
export function fmtHM(mins) {
    const m = ((Math.round(mins) % 1440) + 1440) % 1440;
    return `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;
}
//# sourceMappingURL=parse.js.map